(function () {
	'use strict';

	angular.module('qbePortal').directive('qbValidBsb', ['guideWireService', function (guideWireService) {

		return {
			require: 'ngModel',
			link: function (scope, element, attrs, ngModel) {
				ngModel.gwService = guideWireService;

				ngModel.$setValidity('qbValidBsb', true);

				element.bind('keyup', function (e) {
					if (!ngModel || typeof(element.val()) != 'string') return;

					// var keyProperty = scope.$eval(attrs.wcUnique);
					var currentValue = element.val();
					if (currentValue && currentValue != ''
						&& currentValue.length >= 6
						&& Number.isNumeric(currentValue)
					) {
						ngModel.gwService.isBSBValid(currentValue)
							.then(function (bsbResult) {
								var valid = bsbResult.data ?
									( bsbResult.data.bankName != undefined
									&& bsbResult.data.bankName != 'Unknown' )
									: false;
								ngModel.$setValidity('qbValidBsb', valid);
							}).catch(function () {
							ngModel.$setValidity('qbValidBsb', false);
						});
					} else {
						ngModel.$setValidity('qbValidBsb', true);
						return true;
					}
				});

			}
		};
	}]);
})();
